
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact/corporation",
      function () {
        return require("private-next-pages/contact/corporation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact/corporation"])
      });
    }
  